__turbopack_context__.v({
  "className": "sharpgrotesk20font_1aebee73-module__xEpWja__className",
  "variable": "sharpgrotesk20font_1aebee73-module__xEpWja__variable",
});
